import React from "react";

export default () => (
  <svg viewBox="0 0 24 24">
    <path
      d="M0,1 L23,1 M0,11 L23,11 M0,22 L23,22"
      stroke="#000"
      strokeWidth="2"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/icons/BarsIconSVG.js